import { createRoute, type AnyRoute } from "@tanstack/react-router";
import { Gift } from "lucide-react";

import type { FeatureModule } from "@/features/types";
import { guarded } from "@/lib/auth";

import { MajorSwagPage } from "./pages/MajorSwagPage";

export const majorSwagModule: FeatureModule = {
  key: "major_swag",
  nav: {
    label: "Major Swag",
    icon: Gift,
    to: "/major-swag",
    requires: "major_swag.read",
    // Operations: reconciliation 30, COS-Units 35, Partners 40.
    order: 45,
    group: "Operations",
  },
  routes: (rootRoute) => [
    createRoute({
      getParentRoute: () => rootRoute,
      path: "/major-swag",
      component: guarded("major_swag.read", MajorSwagPage),
    }),
  ] as unknown as AnyRoute[],
};
